import api from 'infra/config/api';

export default function postNewChatComment(data) {
    const url = '/new-chat-comment.php';
    return api
        .url(url)
        .post(data)
        .json();
}